import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import error from 'assets/error1.png';
import styles from './DashboardError.module.css';
export default function DashboardError() {
    const { t } = useTranslation();
    return (_jsxs("section", { className: `fadeIn ${styles.background}`, children: [_jsx("img", { src: error, className: styles.imgIllustration, alt: "Une erreur est survenue lors du t\u00E9l\u00E9chargement des donn\u00E9es" }), _jsx("h1", { children: t('dashboard.error.title') }), _jsx("p", { className: styles.description, children: t('dashboard.error.description') })] }));
}
